module.exports = __webpack_public_path__ + "static/media/shapes_24.cc46f580.svg";